import React from 'react';
import { createPortal } from 'react-dom';
import { useCloseOnEscape } from '../../../hooks/useCloseOnEscape';
import '../styles/SettingsNotificationModal.css';

const SettingsNotificationModal = ({ show, type = 'success', title, message, onClose }) => {
  useCloseOnEscape(show, onClose);
  if (!show) return null;
  const isError = type === 'error';
  const modal = (
    <div className="settings-notification-overlay" role="dialog" aria-modal="true">
      <div className="settings-notification-modal">
        <div className={`settings-notification-icon ${isError ? 'settings-notification-icon--error' : ''}`}>
          <div className="settings-notification-icon-bg">
            {isError ? (
              <span className="settings-notification-error-icon" aria-hidden>!</span>
            ) : (
              <span className="settings-notification-check-icon" aria-hidden>✓</span>
            )}
          </div>
        </div>
        <div className="settings-notification-text">
          <p className="settings-notification-title">{title}</p>
          {message && <p className="settings-notification-subtitle">{message}</p>}
        </div>
        <button
          type="button"
          className="settings-notification-button"
          onClick={onClose}
        >
          Okay, got it
        </button>
      </div>
    </div>
  );
  return createPortal(modal, document.body);
};

export default SettingsNotificationModal;
